if (!customElements.get('scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    constructor() {
      super();
      this._initialized = false;
      this._observer = null;
    }

    connectedCallback() {
      this.promotion = this.querySelector('.promotion');
      if (!this.promotion || this._initialized) return;

      requestAnimationFrame(() => this.init());
      window.addEventListener('load', () => this.init(), { once: true });
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      this._initialized = false;
    }

    init() {
      if (this._initialized || !this.isConnected || !this.promotion) return;
      if (this.querySelectorAll('.promotion').length > 1) {
        this._initialized = true;
        return;
      }

      this._initialized = true;
      this.promotion.classList.add('promotion--animated');

      for (let index = 0; index < 10; index++) {
        this.appendChild(this.promotion.cloneNode(true));
      }

      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.scrollingPlay();
            } else {
              this.scrollingPause();
            }
          });
        },
        { rootMargin: '0px 0px 50px 0px' }
      );

      this._observer.observe(this);

      const rect = this.getBoundingClientRect();
      if (rect.bottom >= 0 && rect.top <= window.innerHeight) {
        this.scrollingPlay();
      }
    }

    scrollingPlay() {
      this.classList.remove('scrolling-promotion--paused');
    }

    scrollingPause() {
      this.classList.add('scrolling-promotion--paused');
    }
  }

  customElements.define('scrolling-promotion', ScrollingPromotion);
}
